module.exports = __webpack_public_path__ + "assets/img/36_1500_big.7b53336a.jpg";